import {
  IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip
  } from "@material-ui/core";
  
  import React from "react";
  import { uniqBy } from "lodash/array";
  import { API_URL } from "../../../../constants/api";
  import {
    apiPut,
    apiRequest
  } from "../../../../utils/api_service";
  import {
    SECTIONS,
    SECURITY_CATEGORY_HEADER,
    getSecurityCategoryColumn,
  } from "../../../../constants/appConstants";
  import TableWithFilter from "../../../common/Table/TableWithFilter";
  import { convertIntoDDFormat } from "../../../../utils/generic";
  import { ShowToast, toastType } from "../../../../utils/toast-service";
  import { IsSectionVisible, isGridFormValid } from "../../../../utils/helper";
  import commonLabels from "../../../../constants/messageConstants"
  import _ from "lodash";
  import SaveIcon from "@material-ui/icons/Save";
  import CancelIcon from "@material-ui/icons/Cancel";
  
  export default class SecurityCategoryMaintenance extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        colFilteredObj: [],
        categoryData: [],
        isInAddMode: false,
        categoryColumns: [],
        validationMessage: []
      };
    }
  
    componentDidMount() {
      this.getCategoryConfigurations();
    }
    
    /**
     * get routing configuration data
     */
    getCategoryConfigurations = () => {
      const params = { incidentParam: "Category" };
      apiRequest({
        url: API_URL.securityIncident.GetSecurityIncidentMasterDataConfiguration,
        params
      }).then(
        ({ data: response }) => {
          const { colFilteredObj } = this.state
          const categoryMasterData = uniqBy(
            convertIntoDDFormat(
              response || [],
              "CategoryId",
              "Category"
            ),
            x => x.id
          );
          const optionsListForCategory = convertIntoDDFormat(
            categoryMasterData || [],
            "value",
            "value"
          );
          const columns = getSecurityCategoryColumn(colFilteredObj, {
            categoryMasterData: optionsListForCategory
          });
          this.setState({
            categoryData: response,
            categoryColumns: columns
          });
        }
      );
    };
  
    /**
     * Add new record
     * @returns 
     */
    AddNewRecord = () => {
      const { isInAddMode, categoryColumns, reloadTable } = this.state;
      if (isInAddMode) {
        ShowToast("You can add one row at a time!", toastType.WARNING, 5000, 500);
        return false;
      }

      let newCategoryColumns = _.cloneDeep(categoryColumns);
      newCategoryColumns = newCategoryColumns.map(col => {
        if (col.isNonEditable) {
          col.editConfig.isEditField = true;
        }
        return col;
      })
      const rowNew = {
        CategoryId: 0,
        Category: null,
        IsActive: "Yes"
      };
  
      this.setState({
        isInAddMode: true,
        selectedEditRowId: { key: "CategoryId", value: 0 },
        reloadTable: !reloadTable,
        updateData: rowNew,
        categoryColumns: newCategoryColumns
      });
    };

    /**
     * activate and deactivate the security category maintenance record
     */
    activateDeactivateRecord = (data) => {
      const params = {
        CategoryId: data.CategoryId,
        isActive: data.IsActive === "Yes" ? 2 : 1
      }
      apiPut({
        url: API_URL.securityIncident.ModifySecurityCategory,
        params
      }).then(({ data: response }) => {
        response.success != true
          ? ShowToast(
              "Server Error: Unable to update category.",
              toastType.ERROR,
              5000,
              500
            )
          : ShowToast(
              "Security Category updated successfully.",
              toastType.SUCCESS,
              5000,
              200
            );  
        this.getCategoryConfigurations();
      });
    }

   /**
   * handle on change
   * @param {*} value
   * @param {*} fieldName
   */
    handleTableEditChange = (value, fieldName) => {
        const { categoryColumns, updateData, validationMessage } = this.state;
        const param = updateData;
        param[fieldName] = value;

        isGridFormValid(value, categoryColumns.find(x => x.key === fieldName), param);
       
        this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) }, () => {
          this.forceUpdate();
        });
    };

    /**
    * render action column on grid table
    * @param {*} cellInfo
    * @returns
    */
    renderActionColumn = (cellInfo) => {
      const { selectedEditRowId } = this.state;
      return (
        <>
          {selectedEditRowId !== undefined &&
            cellInfo.CategoryId === selectedEditRowId.value
            && (
              <>
                <Tooltip title={"Save Record"}>
                  <IconButton
                    aria-label={"refreshData"}
                    size={"small"}
                    onClick={() => { }}
                  >
                    <SaveIcon
                      fontSize={"small"}
                      size={"small"}
                      onClick={this.saveUpdatedRecord}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Cancel"}>
                  <IconButton
                    aria-label={"refreshData"}
                    size={"small"}
                    onClick={this.cancelEditMode}
                  >
                    <CancelIcon fontSize={"small"} size={"small"} />
                  </IconButton>
                </Tooltip>
              </>
            )}
        </>
      );
    };

   /**
   * cancel row open for edit mode
   */
    cancelEditMode = () => {
      const { reloadTable } = this.state
      this.setState({
        selectedEditRowId: undefined,
        isInAddMode: false,
        updateData: undefined,
        reloadTable: !reloadTable
      });
      this.getCategoryConfigurations();
    };

   /**
   * save Updated Record to database
   */
    saveUpdatedRecord = () => {
      const { updateData, reloadTable } = this.state;
      if (!this.isValidForm()) { return false; } 
      else if (this.isAlreadyExist(updateData)){
        return false
      }
      else {
          const newParam = {
            Category: updateData.Category,
            CategoryId: updateData.CategoryId,
            listOrderBy: Math.floor(Number(updateData.ListOrderBy))
          };
          apiPut({
            url: API_URL.securityIncident.SaveSecurityIncidentCategory,
            postBody: newParam
          }
          ).then(({ data: response }) => {
            if (response.success === true) {
              ShowToast(
                "Record added successfully.",
                toastType.SUCCESS,
                5000,
                500
              );

              this.setState({
                updateData: undefined,
                selectedEditRowId: undefined,
                reloadTable: !reloadTable,
                isInAddMode: false
              }, () => {
                this.getCategoryConfigurations();
                this.forceUpdate();
              });
            } else {
              ShowToast(
                response.message,
                toastType.ERROR,
                5000,
                5000
              );
            }
          });
        }      
    };

    /**
     * is Form Valid
    */
    isValidForm = () => {
      let IsValid = true;
      const { updateData, categoryColumns } = this.state;
      categoryColumns.forEach((ele) => {
        isGridFormValid(updateData[ele.key], ele, updateData);
        if (ele.isInErrorState === true) {
          IsValid = false;
        }
      });
      this.setState({ categoryColumns }, this.forceUpdate());
      return IsValid;
    };

    /**
     * edit the record
     * @param {*} cellInfo 
     */
    editRecord = (cellInfo) => {
      const { categoryColumns, reloadTable } = this.state;
      let newCategoryColumns = _.cloneDeep(categoryColumns);
      newCategoryColumns = newCategoryColumns.map(col => {
        if (cellInfo.IsDefault && col.isNonEditable) {
          col.editConfig.isEditField = false;
        }
        return col;
      })
      this.setState({
        categoryColumns: newCategoryColumns,
        selectedEditRowId: {
          key: "CategoryId",
          value: cellInfo.CategoryId
        },
        isInAddMode: false,
        updateData:  { ...cellInfo },
        reloadTable: !reloadTable
      });
    }

    /**
     * check for exists in the system
     * @param {*} data 
     * @returns 
     */
    isAlreadyExist = (data) => {
      const { categoryData } = this.state;
      let fieldName = "";
      let isExist = false;
       if(categoryData.find(x=> x.Category === data.Category && x.CategoryId !== data.CategoryId) !== undefined) {
        fieldName = "Category";
        isExist = true;
       } 
       if(categoryData.find(x=> parseInt(x.ListOrderBy) === parseInt(data.ListOrderBy) && x.CategoryId !== data.CategoryId) !== undefined) {
        fieldName += fieldName === "" ? "List Order by" : ", List Order by";
        isExist = true;
       } 
       if (fieldName != "" && isExist) {
        ShowToast(
          fieldName + " already exist in the system.",
          toastType.ERROR,
          5000,
          500
        );
       }
       return isExist;
    }


    render() {
      const {
        categoryData,
        selectedEditRowId,
        updateData,
        isInAddMode,
        reloadTable,
        validationMessage
      } = this.state;
     const {tooltip} = this.props;
      let { categoryColumns } = this.state;
      const isVisible = IsSectionVisible(
        SECTIONS.CONFIGURATION,
        SECTIONS.CONFIGURE_ROUTING_AND_NOTIFICATION,
        SECTIONS.ADD_EDIT
      );
      categoryColumns = !isVisible
        ? categoryColumns.filter(x => x.colName !== "Action")
        : categoryColumns;
  
      return (
        <>
          <Table
            aria-labelledby={"tableMenuTitle"}
            size={"small"}
            aria-label={"configuration table"}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  key={"configureHeader"}
                  className={"content-header"}
                  colSpan={2}
                >
                  <div className={"content-header d-flex"}>
                    {" "}
                    <div
                      className={"col-xs-11"}
                      style={{ display: "inline-block", alignItems: "center" }}
                    >
                      {"Security Category Maintenance Configuration\r"}
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <TableWithFilter
                    renderActionColumn={this.renderActionColumn}
                    selectedEditRowId={selectedEditRowId}
                    isInAddMode={isInAddMode}
                    EditSource={[]}
                    handleTableValueChange={this.handleTableEditChange}
                    updateData={updateData}
                    deactivationMessage={commonLabels.deactivationForCategoryConfirmation.message}
                    activationMessage={commonLabels.activationForCategoryConfirmation.message}
                    visibilityAction={{
                      isActionVisible: isVisible
                    }}
                    AddNewRecord={{
                      action: this.AddNewRecord,
                      title: "Add Security Category",
                      visible: true
                    }}
                    activateDeactivateRecord={this.activateDeactivateRecord}
                    tableHeader={SECURITY_CATEGORY_HEADER}
                    columns={categoryColumns}
                    originalData={categoryData}
                    toolTipData={tooltip}
                    reloadTable={reloadTable}
                    resetPage={this.getCategoryConfigurations}
                    validationMessage={validationMessage || []}
                    isInline
                    editRecord={this.editRecord}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </>
      );
    }
  }
  